const ACTIVE_SUBSCRIPTION_ERROR_NAME = 'ActiveSubscriptionError';
const DUPLICATE_SUBSCRIPTION_ERROR_CODE = 'DUPLICATE_SUBSCRIPTION';

export function createActiveSubscriptionError(message: string): Error {
  const error = new Error(message);
  error.name = ACTIVE_SUBSCRIPTION_ERROR_NAME;
  return error;
}

export function isActiveSubscriptionError(error: unknown): boolean {
  return error instanceof Error && error.name === ACTIVE_SUBSCRIPTION_ERROR_NAME;
}

export function isDuplicateSubscriptionError(error: unknown): boolean {
  return getSubscriptionErrorCode(error) === DUPLICATE_SUBSCRIPTION_ERROR_CODE;
}

function getSubscriptionErrorCode(error: unknown): string | undefined {
  const errorRecord = error as {
    response?: {
      data?: {
        errorCode?: unknown;
      };
    };
  };

  return typeof errorRecord?.response?.data?.errorCode === 'string'
    ? errorRecord.response.data.errorCode
    : undefined;
}
